export class Model_CrmType
    {      
  
        public Crm_Type_Name : string;
        public CRMTypeId : number;
        
    }       